import type { WCmsPageView } from '@zola/svc-web-api-ts-client';
import React from 'react';
import type { RouteComponentProps } from 'react-router';

import EditPageFormV2WithRouter from './EditPageFormV2';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface EditPageFormContainerProps extends RouteComponentProps<any, any> {
  page: WCmsPageView;
  valid: boolean;
  galleryMultiPhoto?: boolean;
}

const EditPageFormContainer: React.FC<EditPageFormContainerProps> = props => (
  <EditPageFormV2WithRouter {...props} />
);

export default EditPageFormContainer;
